
export default {
  props: {
    product: {
      type: Object,
      default: { }
    },
    list: {
      type: String,
      required: true
    },
    position: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      adding: false
    }
  },
  methods: {
    _addToCart () {
      if (this.adding) {
        return
      }
      this.adding = true
      let self = this
      setTimeout(function () { self.adding = false }, 1500)

      let currency = this.$store.getters.currency
      let price = this.product.prices[currency.currency]
      if (!price) {
        // todo How to handle?
        console.log('no price found for product \'' + this.product + '\' in currency \'' + currency + '\'')
        price = 0
      }

      let item = {}
      item.type = this.product.type
      item.product = {
        key: this.product.key,
        name: this.product.name,
        id: this.product.key,
        url: this.product.url,
        category: item.type,
        brand: this.product.brand,
        variant: this.product.variant
      }
      item.count = 1
      item.price = {
        amount: price,
        currency: this.$store.getters.currency.currency
      }
      // List and position are needed for the enhanced ecommerce
      item.list = this.list
      item.position = this.position

      // We can't add the item directly, since VueJS optimizes the clean item into a cache, which then alters all items
      // in the cart.
      this.$store.dispatch('addItem', JSON.parse(JSON.stringify(item)))
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/productMixin.js